"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (string, suffix) {
  return string.substr(-suffix.length) === suffix;
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/polished/lib/internalHelpers/_endsWith.js
// module id = 73
// module chunks = 22676092666560 46504955462500 107818501498521 221374088121123